import { Inject } from '../Application';
import { Constants, RequestType } from '../Contract';
import { Request } from '.';
var RequestBuilder = (function () {
    function RequestBuilder(inject) {
        if (inject === void 0) { inject = null; }
        this.inject = inject;
        this.inject = inject || Inject.Instance;
        this.library = this.inject.resolve(Constants.Library);
    }
    RequestBuilder.prototype.create = function (action) {
        var request;
        switch (action.requestConfig.requestType) {
            case RequestType.ModelRequest:
                request = new Request();
                request.vm = action.item ? action.item.UniqueID : '';
                this.library.dom.extend(request, action.parameters);
                break;
            case RequestType.RawRequest:
                request = action.parameters;
                break;
            default:
                request = new Request();
                request.parameters = action.parameters;
                break;
        }
        return request;
    };
    return RequestBuilder;
}());
export { RequestBuilder };
